/* assets/eh-cashback-carrinho.js */
(function () {
  if (window.__ehCashbackCarrinhoInit) return;
  window.__ehCashbackCarrinhoInit = true;

  function $all() {
    return Array.from(document.querySelectorAll('[data-eh-cashback]'));
  }

  function formatMoney(cents, el) {
    cents = Math.max(0, Math.round(Number(cents || 0)));

    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        const mf = (el && el.dataset && el.dataset.moneyFormat) ? el.dataset.moneyFormat : "${{amount}}";
        return Shopify.formatMoney(cents, mf);
      }
    } catch (e) {}

    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
    } catch (e2) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function ensureAmountPlaceholder(tpl) {
    // Se não tiver {{amount}}, a gente injeta o placeholder sem adicionar frase fixa
    if (/{{\s*amount\s*}}/.test(tpl)) return tpl;

    // Se começar com "Ganhe", injeta logo após "Ganhe"
    if (/^\s*ganhe\b/i.test(tpl)) {
      return tpl.replace(/^\s*ganhe\b/i, 'Ganhe {{amount}}');
    }

    // Caso genérico: só adiciona no final
    return (tpl + ' {{amount}}').trim();
  }

  function render(el, cart) {
    if (!el || !cart) return;

    const total = Number(cart.total_price || 0);
    const threshold = Number(el.dataset.thresholdCents || 0);
    const pctBelow = Number(el.dataset.pctBelow || 0);
    const pctAbove = Number(el.dataset.pctAbove || 0);

    const pct = total >= threshold ? pctAbove : pctBelow;

    if (total <= 0 || pct <= 0) {
      el.style.display = 'none';
      return;
    }

    const cashbackCents = Math.round(total * pct / 100);
    if (cashbackCents <= 0) {
      el.style.display = 'none';
      return;
    }

    // TEMPLATE VEM DO SETTINGS (data-template). Sem frase fixa aqui.
    let tpl = (el.dataset.template || '').trim();

    // Se o template estiver vazio, esconde (não inventa texto)
    if (!tpl) {
      el.style.display = 'none';
      return;
    }

    tpl = ensureAmountPlaceholder(tpl);

    const money = formatMoney(cashbackCents, el);

    // ✅ LIMPA O CONTAINER INTEIRO (mata sobras/duplicações)
    el.replaceChildren();

    const text = document.createElement('span');
    text.className = 'eh-cashback__text';

    const parts = tpl.split(/{{\s*amount\s*}}/g);
    parts.forEach((part, idx) => {
      if (part) text.appendChild(document.createTextNode(part));
      if (idx < parts.length - 1) {
        const amount = document.createElement('span');
        amount.className = 'eh-cashback__amount';
        amount.textContent = money;
        text.appendChild(amount);
      }
    });

    el.appendChild(text);
    el.style.display = '';
  }

  let t = null;
  async function refresh() {
    clearTimeout(t);
    t = setTimeout(async () => {
      const els = $all();
      if (!els.length) return;

      try {
        const r = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!r.ok) return;
        const cart = await r.json();
        els.forEach(el => render(el, cart));
      } catch (e) {}
    }, 120);
  }

  // 1) Patch fetch
  if (window.fetch) {
    const _fetch = window.fetch;
    window.fetch = function () {
      const p = _fetch.apply(this, arguments);
      try {
        const u = arguments[0];
        const url = typeof u === 'string' ? u : (u && u.url) ? u.url : '';
        if (url && url.indexOf('/cart/') !== -1) {
          p.then(refresh).catch(() => {});
        }
      } catch (e) {}
      return p;
    };
  }

  // 2) Patch XHR
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ehUrl = url;
    return _open.apply(this, arguments);
  };
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('loadend', () => {
      try {
        if (this.__ehUrl && String(this.__ehUrl).indexOf('/cart/') !== -1) refresh();
      } catch (e) {}
    });
    return _send.apply(this, arguments);
  };

  // 3) Observer
  const obs = new MutationObserver((records) => {
    for (const r of records) {
      try {
        if (r.target && r.target.closest && r.target.closest('[data-eh-cashback]')) continue;
      } catch (e) {}
      refresh();
      break;
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // 4) Eventos comuns
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('shopify:section:load', refresh);

  // init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
